module.exports = __webpack_public_path__ + "img/24_35.5a79ff87.png";